<template>
	<b-container fluid>
		<b-row class="h-100">
			<b-col class="p-0 d-flex w-100">
				<sidebar-menu
					:menu="menu"
					theme="white-theme"
					width="250px"
					:relative="true"
				/>
				<router-view></router-view>
			</b-col>
		</b-row>
	</b-container>
</template>

<script>
//import pdf from "vue-pdf";
//import atendimentosData from "@/data/atendimentos";
//import Cabecalho from "@/components/template/Cabecalho.vue";
//import Rodape from "@/components/template/Rodape.vue";
import permissionsMixin from "@/mixins/permissionsMixin.js";

export default {
	mixins: [permissionsMixin],
	components: {},
	data() {
		return {
			menuAutorizarRefeicoes: null,
			menu: [
				{
					title: "Autorizar refeições",
					icon: "fa fa-cutlery",
					href: "/refeicoes",
					hidden: !this.hasPermission("menuAutorizarRefeicoes"),
				},
				{
					title: "Autorização em lote",
					icon: "fa fa-cutlery",
					hidden: !this.hasPermission("menuAutorizarEmLote"),
					child: [
						{
							title: "Autorizar",
							href: "/emlote/autorizar",
						},
						{
							title: "Excluir autorização",
							href: "/emlote/excluir",
						},
					],
				},
				{
					title: "Cadastros",
					icon: "fa fa-chart-area",
					hidden: !this.hasPermission("menuCadastros"),
					child: [
						{
							title: "Escalas",
							href: "/escalas",
							hidden: !this.hasPermission("menuEscalas"),
						},
						{
							title: "Usuário",
							href: "/usuarios",
							hidden: !this.hasPermission("menuUsuarios"),
						},
						{
							title: "Perfis",
							href: "/perfis",
							hidden: !this.hasPermission("menuPerfis"),
						},
						{
							title: "Tipos de refeições",
							href: "/tiposderefeicoes",
							hidden: !this.hasPermission("menuTiposDeRefeicoes"),
						},
						{
							title: "Tipos de plantão",
							href: "/tiposdeplantao",
							hidden: !this.hasPermission("menuTiposDePlantao")
						},
						{
							title: "Tipos de escala",
							href: "/tiposdeescala",
							hidden: !this.hasPermission("menuTiposDeEscala")
						},
						{
							title: "Feriados",
							href: "/feriados",
							hidden: !this.hasPermission("menuFeriados"),
						},
					],
				},
				{
					title: "Configurações",
					icon: "fa fa-gear",
					hidden: !this.hasPermission("menuConfiguracoes"),
					href: "/configuracoes",
				},
				{
					title: "Plantões",
					icon: "fa fa-calendar-alt",
					hidden: !this.hasPermission("menuPlantoes"),
					href: "/plantoes",
				},
				{
					title: "Meus absenteísmos",
					icon: "fa fa-calendar-alt",
					hidden: !this.hasPermission("menuMeusAbsenteismos"),
					href: "/meusabsenteismos"
				},
				{
					title: "Casa da Gestante",
					icon: "fa fa-female",
					hidden: !this.hasPermission("menuCasaDaGestante"),
					child: [
						{
							title: "Cadastros",
							hidden: !this.hasPermission(
								"menuCasaDaGestanteCadastros"
							),
							child: [
								{
									title: "Dormitórios",
									icon: "fa fa-bed",
									hidden: !this.hasPermission(
										"menuCasaDaGestanteCadastrosDormitorios"
									),
									href: "/casadagestante/dormitorio",
								},
								{
									title: "Perfis",
									icon: "fa fa-address-card",
									hidden: !this.hasPermission(
										"menuCasaDaGestanteCadastrosPerfis"
									),
									href: "/casadagestante/perfil",
								},
							],
						},
						{
							title: "Censo",
							hidden: !this.hasPermission(
								"menuCasaDaGestanteCenso"
							),
							href: "/casadagestante/censo",
						},
						{
							title: "Autorização em lote",
							icon: "fa fa-cutlery",
							hidden: !this.hasPermission(
								"menuCasaGestanteAutorizarEmLote"
							),
							child: [
								{
									title: "Autorizar",
									href: "/casadagestante/emlote/autorizar",
								},
								{
									title: "Excluir autorização",
									href: "/casadagestante/emlote/excluir",
								},
							],
						},
					],
				},
				{
					title: "Relatórios",
					icon: "fa fa-chart-area",
					hidden: !this.hasPermission("menuRelatorios"),
					child: [
						{
							title: "Confirmações de Refeições",
							href: "/relatorio/confirmacaoderefeicao",
							hidden: !this.hasPermission(
								"relatorioConfirmacaoRefeicao"
							),
						},
						{
							title: "Quantitativo de Refeições",
							href: "/relatorio/quantitativoderefeicoes",
							hidden: !this.hasPermission(
								"relatorioQuantitativoDeRefeicoes"
							),
						},
						{
							title: "Registro de Entrada",
							href: "/relatorio/registrodeentrada",
							hidden: !this.hasPermission(
								"relatorioRegistroDeEntrada"
							),
						},
						{
							title: "Extrato de Paciente",
							href: "/relatorio/extratodepaciente",
							hidden: !this.hasPermission(
								"relatorioExtratoDePaciente"
							),
						},
						{
							title: "Profissionais Escalados",
							href: "/relatorio/profissionaisescalados",
							hidden: !this.hasPermission(
								"relatorioProfissionaisEscalados"
							),
						},
						{
							title: "Relatório de absenteísmo",
							href: "/relatorio/absenteismo",
							hidden: !this.hasPermission("relatorioAbsenteismo"),
						},
					],
				},
				{
					title: "Mural",
					icon: "fa fa-calendar-alt",
					href: "/mural",
					hidden: !this.hasPermission("acessarMural"),
					//external: true,
				},
			],
		};
	},
	computed: {
		rows() {
			return this.atendimentos.length;
		},
	},
};
</script>

<style>
table {
	cursor: pointer;
}
.modal-dialog-scrollable {
	height: 100%;
}

/* .v-sidebar-menu {
  position: relative !important;
  height: 100% !important;
  left: 0px !important;
} */
</style>
